<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TextTruncationMultiLine',

  props: {
    /**
     * 表示最大行数
     * @description 0 の場合は無制限
     */
    maxLine: {
      type: Number,
      default: 2,
      validator: (value: number) => value >= 0,
    },

    /**
     * ルート要素に付与するクラス
     * @description モジュールクラスと要素クラスは排他であり両立しないため、
     *              モジュールクラスを付与したい場合に外から注入する。
     *              無指定の場合は要素クラス（span）をフォールバックとして付与する
     */
    className: {
      type: String,
      default: 'span',
    },
  },
})
</script>

<template>
  <span
    :class="className"
    :style="{
      '-webkit-line-clamp': maxLine > 0 ? maxLine : undefined,
    }"
    :data-truncated="maxLine > 0">
    <slot />
  </span>
</template>

<style lang="sass" scoped>
  span[data-truncated="true"]
    display: -webkit-box
    overflow: hidden
    text-overflow: ellipsis
    -webkit-box-orient: vertical
</style>
